import React, { useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getTexts } from "../../api/text";
import logoMedical from "../../assets/logo-medical.png";
import NextButton from "../../components/NextButton";
import { ROUTES } from "../../utils/constants";
import { getScenarioByScreen } from "../../utils/helpers";

function parseSteps(stepsText) {
	if (!stepsText || typeof stepsText !== "string") return [];
	return stepsText
		.split(/\n/)
		.map((line) => line.trim())
		.filter(Boolean)
		.map((line) => {
			const m = line.match(/^(\d+)\.\s*(.*)$/s);
			return m ? { num: m[1], text: m[2].trim() } : { num: "", text: line };
		});
}

function Scenario6End({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const participant = useSelector((state) => state.group);

	const [intro, setIntro] = useState("");
	const [steps, setSteps] = useState("");

	const scenarioNum = getScenarioByScreen(location.pathname);
	const stepsList = parseSteps(steps);

	useEffect(() => {
		const gameId = participant?.game;
		if (!gameId) return;
		getTexts({ game: gameId })
			.then((res) => {
				if (res.status === 200 && Array.isArray(res.data)) {
					const map = res.data.reduce((acc, t) => ({ ...acc, [t.key]: t.value }), {});
					if (map["scenario6-end.intro"] != null && map["scenario6-end.intro"] !== "") setIntro(map["scenario6-end.intro"]);
					if (map["scenario6-end.steps"] != null && map["scenario6-end.steps"] !== "") setSteps(map["scenario6-end.steps"]);
				}
			})
			.catch(() => {});
	}, [participant?.game]);

	return (
		<div className="h-100">
			<div className="container-fluid bg-internas">
				<div style={{ paddingTop: "6vh", paddingLeft: "6vh" }}>
					<img width={240} src={logoMedical} />
				</div>
				<div className="row d-flex justify-content-center align-items-center mt-5">
					<div className="col-8">
						<div className="d-flex flex-column align-items-center">
							<div
								className="txt18 bold txt-white mt-5 text-center"
								dangerouslySetInnerHTML={{ __html: intro }}
							/>
							<div
								className="p-4 bg-yellow option-selected w-75"
								style={{ borderRadius: "10px" }}
							>
								{stepsList.map((item, i) => (
									<div
										key={i}
										className="d-flex align-items-start justify-content-start mt-2"
										style={i === 0 ? {} : { marginTop: "0.5rem" }}
									>
										<div>{item.num}{item.num ? "." : ""}</div>
										<div className="ms-2" dangerouslySetInnerHTML={{ __html: item.text }} />
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				className="container"
				style={{
					position: "absolute",
					bottom: "8vh",
				}}
			>
				<div className="d-flex justify-content-end">
					<NextButton
						navigateTo={ROUTES.TRANSITION_SCENARIOS}
						activeScenario={scenarioNum + 1}
					/>
				</div>
			</div>
		</div>
	);
}

export default injectIntl(Scenario6End);
